// 国际市场
<template>
  <div class="subpage inter" :style="rootVars">
    <div class="flx-bs container">
      <div class="left">
        <div class="part">
          <div class="head flx-bc">
            <div><span class="title"><i class="icon icon-pm"></i>{{ $C('international','auctionTitle','拍卖结果') }}</span><span>{{result.title}}</span></div>
            <a :href="result.GDTurl" target="_blank" class="link">{{ $C('international','gdtLinkText','Go GDT') }}</a>
          </div>
          <ul class="flx-bc box">
            <li :class="'li'+index" v-for="(item,index) in result.data1" :key="item.name">
              <div class="bg"></div>
              <div class="info">
                <h3 class="title" :style="$width===6144?{'font-size':'34px'}:''">{{item.name}}</h3>
                <p class="flx-cc"><span>{{item.value}}</span><i v-if="index===0" class="icon" :class="item.value.indexOf('+')>-1?'icon-up':'icon-down'"></i></p>
              </div>
            </li>
          </ul>
          <ul class="flx list">
            <li v-for="item in result.data2" :key="item.name">
              <label>{{item.name}}：</label>
              <span>{{item.value}}</span>
            </li>
          </ul>
        </div>
        <div class="part" :style="$width===6144?{'margin-top':'140px'}:''">
          <div class="head flx-bc">
            <span class="title"><i class="icon icon-tb"></i>{{ $C('international','priceIndexTitle','GDT 价格指数变化') }}</span>
            <span @click="tenShow=true" class="link">{{ $C('international','priceIndexLink','查看 10年以来的GDT 价格指数') }}</span>
          </div>
          <div class="gdtBox" id="gdt"></div>
        </div>
      </div>
      <div class="middle" :style="$width===6144?{'margin-top':'70px'}:''">
        <div class="map" id="map"></div>
      </div>
      <div class="right">
        <div class="part">
          <div class="head"><span class="title"><i class="icon icon-cp"></i>{{ $C('international','productTitle','产品') }}</span></div>
          <ul class="flx plist">
            <li v-for="(item,index) in result.product" :key="index" @click="goProduct(item)">
              <h3>{{item.name}}</h3>
              <CircleProgress :value="item.percent" :info="item" :color="item.compared.indexOf('-')>-1?'#FF8B17':'#0DFF0D'" :size="240" />
            </li>
          </ul>
        </div>
        <div class="part" :style="$width===6144?{'margin-top':'100px'}:''">
          <div class="head"><span class="title"><i class="icon icon-news"></i>{{ $C('international','newsTitle','最新动态') }}</span></div>
          <ul class="nlist">
            <li v-for="(item,index) in news" :key="index" @click="newsShow=true;newsUrl=item.url">{{item.title}}</li>
          </ul>
        </div>
      </div>
    </div>
    <TenYear v-if="tenShow" :visible.sync="tenShow" :title="$C('international','tenYearTitle','10年以来的GDT 价格指数')" :data="result.tenYear"></TenYear>
    <Product v-if="productShow" :visible.sync="productShow" :title="productInfo.name+$C('international','productTitleSep','—拍卖结果')+result.title" :info="productInfo"></Product>
    <News v-if="newsShow" :visible.sync="newsShow" :title="$C('international','newsTitle','最新动态')" :url="newsUrl"></News>
  </div>
</template>

<script>
import axios from "axios"
import CircleProgress from '../common/circle.vue';
import echarts from 'echarts'
import 'echarts/map/js/world'
// 地图翻译文件
import { nameMap } from '../../../public/assets/geo/nameMap'
import TenYear from './tenyear';
import Product from './product.vue';
import News from '../common/newsDig.vue'
import { mediaUrl } from '@/cms/config'
export default {
  components: { CircleProgress,TenYear, Product,News },
  data() {
    return {
      result: {title:''},
      news: [],
      mapData: [],
      tenShow: false,
      productShow: false,
      productInfo: {},
      newsShow: false,
      newsUrl: {},
    };
  },
  computed: {
    rootVars() {
      const bg = this.$C('international', 'pageBg', '')
      return bg ? { background: `url("${mediaUrl(bg)}") center/cover no-repeat #061634` } : {}
    },
  },
  mounted() {
    
  },
  watch: {
    '$route.path':{
      handler(path){
        if(path==='/international'){
          // this.fetchData('/assets/international.json')
          this.getData('international')
        }
      },
      immediate: true
    }
  },
  methods: {
    getData(name){
      let params = {fileName: name}
      axios.post(this.$baseUrl+'/api/web/file/data/query',params).then(res => {
        if(res.data.code === 200){
          const jsonData = res.data.data
          this.result = jsonData.result
          this.news = jsonData.news
          this.mapData = jsonData.mapData
          this.$nextTick(() => {
            this.echartsMap()
            this.echarts()
          })
        }
      })
    },
    fetchData(path) {
      axios.get(path+'?t=' + Date.now()).then(res => {
        const jsonData = res.data
        this.result = jsonData.result
        this.news = jsonData.news
        this.mapData = jsonData.mapData
        this.$nextTick(() => {
          this.echartsMap()
          this.echarts()
        })
      })
    },
    echartsMap(){
      var that = this
      var map = echarts.init(document.getElementById('map'));
      // 设置地图配置
      var option = {
        grid: {
          left: 0,   // 左侧距离
          right: 0,  // 右侧距离
          top: 0,   // 可选：顶部距离
          bottom: 0, // 可选：底部距离
        },
        tooltip: {
          trigger: 'item',
          backgroundColor: 'rgba(0,0,0,0.6)',
          borderRadius: 15,
          textStyle: {
            color: '#ffffff',
            fontSize: 36
          },
          formatter(params) {
            const data = params.data;
            if (!data) {
                return `
                <div style='padding: 36px 21px 48px 57px;width:432px;'>
                  <h3 style='font-size:42px;font-weight:700;line-height:60px'>${params.name}</h3>
                </div>`
            }
            return  `
            <div style='padding: 36px 21px 48px 57px;width:432px;font-size:36px;line-height:50px;'>
              <h3 style='font-size:42px;font-weight:700;margin-bottom:2px;line-height:60px'>${params.name}</h3>
              <p style="margin-bottom:10px;white-space:wrap">${data.intro}</p>
              <p style='white-space:wrap;'>${data.brands}</p>
            </div>`
          },
        },
         geo: [
            //第一层投影
            {
                left: 12,
                top: 12,
                width: '100%',
                height: '100%',
                map: 'world',
                zlevel: -1,
                roam: false, // 鼠标缩放+平移
                show: true,
                selectedMode: false,
                silent: true, // 禁用鼠标交互
                label: {
                    normal: {
                        show: false
                    },
                    emphasis: {
                        show: false
                    }
                },
                itemStyle: {
                    normal: {
                        areaColor: "#0345A1",
                        shadowOffsetX: 0,
                        shadowOffsetY: 0,
                        // shadowBlur: 10
                    },
                    emphasis: {
                        show: false
                    }
                },
                emphasis:{
                    show:false
                },
                tooltip:{
                    show:false
                }
            }
        ],
        series: [
          {
            // 上层地图
            left: 0,
            top: 0,
            width: '100%',
            height: '100%',
            name: '世界地图',
            type: 'map',
            mapType: 'world',
            roam: false,
            itemStyle: {
              // areaColor: '#387FE9',
              areaColor: new echarts.graphic.LinearGradient(0, 0, 1, 0,[
                {offset: 0, color: '#387FE9'},
                {offset: 1, color: '#225FBA'}
              ]),
              borderWidth: 3,
              borderColor: '#42AAFF',
            },
            emphasis: {
              itemStyle: {
                  areaColor: new echarts.graphic.LinearGradient(0, 0, 1, 0,[
                    {offset: 0, color: '#F9B841'},
                    {offset: 1, color: '#FF6524'}
                  ]),
                  borderWidth: 3,
                  borderColor: '#FFD942',
              }
            },
            label: {
              normal: {
                show: false,
              },
              emphasis: {
                show: false,
              },
            },
            nameMap: nameMap,
            data: that.mapData,
          }
        ],
      }
      // 设置配置项
      map.setOption(option);
    },
    echarts(){
      var chart = echarts.init(document.getElementById('gdt'));
      let dataX = this.result.oneYear.map(it => {
        return it.time
      })
      let dataY = this.result.oneYear.map(it => {
        return it.value
      })
      // 清空图表
      chart.clear();
      chart.setOption({
        // 设置绘图区域的边距
        grid: {
          left: 0,   // 左侧距离
          right: 129,  // 右侧距离
          top: 30,   // 可选：顶部距离
          bottom: 0, // 可选：底部距离
          containLabel: true // 确保标签不被裁剪
        },
        tooltip: {
          trigger: 'axis',
          textStyle: {
            color: '#fff',
            fontSize: 36, 
            fontWeight: 'bold', 
          },
        },
        xAxis: {
          type: 'category',
          data: dataX,
          axisTick: {
            show: false
          },
          axisLine: {
            lineStyle: {
              color: '#435D8C', // 设置 x 轴线的颜色
              width: 36,      // 设置 x 轴线的宽度
            }
          },
          boundaryGap: false, // 去掉左右两边的空白
          axisLabel: {
            color: '#fff', // 文字颜色
            fontSize: 28,   // 字体大小
            margin: 57
          }
        },
        yAxis: {
          type: 'value',
          axisLine: { show: false },
          splitLine: { show: false },
          axisTick: { show: false },
          axisLabel: {
            color: '#fff', // 文字颜色
            fontSize: 37,   // 字体大小
            margin: 100,
            formatter: '{value}%'
          },
          min: -6,
          max: 6,
          interval: 2 // 每隔2一个刻度
        },
        series: [
          {
            data: dataY,
            type: 'bar',
            showBackground: true,
            backgroundStyle: {
              color: '#16293B'
            },
            barWidth: 86,
            barGap: 86,
            itemStyle: {
              color: '#306CDA' // 柱子颜色
            }
          }
        ]
      })
    },
    goProduct(val){
      if(!val.tip){
        this.productShow = true
        this.productInfo = val
      }
    }
  },
};
</script>
<style lang="less" scoped>
@import '@/styles/inter';
</style>